import type { RouteRecordRaw } from "vue-router";

export type SystemLogsRouteOptions = {
  path?: string;
  name?: string;
  meta?: RouteRecordRaw["meta"];
};

export function createSystemLogsRoutes(options: SystemLogsRouteOptions = {}): RouteRecordRaw[] {
  const {
    path = "/admin/logs",
    name = "system-logs",
    meta = {
      title: "Logs del Sistema",
      breadcrumb: ["Sistema", "Logs"],
      requiresAuth: true,
      roles: ["ADMIN"],
    },
  } = options;

  return [
    {
      path,
      name,
      component: () => import("@template/pages/SystemLogsPage.vue"),
      meta,
    },
  ];
}
